/* tslint:disable */

declare var Object: any;
export interface TimezoneInterface {
  createdby?: string;
  lastupdatedby?: string;
  id?: any;
  createdAt: Date;
  updatedAt: Date;
}

export class Timezone implements TimezoneInterface {
  createdby: string;
  lastupdatedby: string;
  id: any;
  createdAt: Date;
  updatedAt: Date;
  constructor(data?: TimezoneInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Timezone`.
   */
  public static getModelName() {
    return "Timezone";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Timezone for dynamic purposes.
  **/
  public static factory(data: TimezoneInterface): Timezone{
    return new Timezone(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Timezone',
      plural: 'timezones',
      properties: {
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Timezone.ts